export const message = {
    subscribeToPromotion: 'YOU ARE IN! WE ARE BUILDING THIS NOW AND WILL CONTACT YOU WHEN THIS TOOL IS READY!',
    invalidEmail: 'Invalid email or role. Please provide valid inputs.',
    emptyEmail: 'Email field cannot be empty. Please enter a valid email address',
    subscribeToPlanPromotion: 'YOU ARE IN! WE ARE JUST COLLECTING EMAILS FOR NOW. WE WILL ADD THIS SOON!',
}
  